import { render, staticRenderFns } from "./accountgraphexample.vue?vue&type=template&id=96887f5c&scoped=true&"
import script from "./accountgraphexample.vue?vue&type=script&lang=js&"
export * from "./accountgraphexample.vue?vue&type=script&lang=js&"
import style0 from "./accountgraphexample.vue?vue&type=style&index=0&id=96887f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96887f5c",
  null
  
)

export default component.exports